export const favoriteListErrorMessageId = (status) => {
  if (status === 409) return 'FavoriteLists.Error.DuplicateName';
  if (status === 400) return 'FavoriteLists.Error.LimitReached';
  return 'FavoriteLists.Error.Generic';
};
